export default {"src":"/_next/static/media/app-store.5bd575f2.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};